// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

import { WebAppEnvironment } from './types';
import { getSubdomainAssets } from '@readcloud/common/lib/utils/utils';
const { clientId } = getSubdomainAssets();

// Check if we're in a Tauri environment
const isTauri = (window as any).__TAURI__ !== undefined;

// Check if we're running as winc app (via env var set during build).
// This uses build-time detection only (VITE_WINC_APP) rather than runtime hostname
// detection like libs/common/src/lib/isWincApp.ts, because this file is evaluated
// at module load time to set up OAuth redirect URLs which must be determined
// before window.location is reliably available in the Tauri context.
const isWincApp = !!(import.meta as any).env?.VITE_WINC_APP;

// Define base URL for OAuth redirects.
// OAuth requires reverse domain name based schemes for native apps.
// - ReadCloud: com.readcloud.nativeapp://app
// - Winc: com.winc.ebooks://app
// Note: Deep links use simpler schemes (readcloud://, winc://) but OAuth is separate.
const getBaseUrl = () => {
  if (!isTauri) return location.origin;
  return isWincApp ? 'com.winc.ebooks://app' : 'com.readcloud.nativeapp://app';
};
const baseUrl = getBaseUrl();

if (import.meta.env.DEV) {
  console.log('OAuth Base URL:', baseUrl);
  console.log('Is Tauri:', isTauri);
  console.log('Is Winc App:', isWincApp);
}

export const environment: WebAppEnvironment = {
  auth: {
    client_id: clientId,
    redirect_uri: `${baseUrl}/authentication/callback`,
    post_logout_redirect_uri: baseUrl,
    response_type: 'code',
    scope: 'openid profile email offline_access',
    authority:
      import.meta.env.VITE_ACCOUNTS_AUTHORITY ||
      'https://accounts.readcloud-test.com',
    silent_redirect_uri: `${baseUrl}/authentication/silent_callback`,
    automaticSilentRenew: true,
    triggerAuthFlow: true,
  },
  posthog_id: 'phc_2MutYC8qqc7ITzJEMiomP92Utpjk5g8pNCbrbeqN8Zl',
  content_url:
    import.meta.env.VITE_CONTENT_APP_HOST ||
    'content-html-assets.readcloud.com',
};
